export enum LocalTableConfigType {
  ASK_YOUR_ALERT_TXN_EVENTS_TABLE = 'ASK_YOUR_ALERT_TXN_EVENTS_TABLE',
  ASK_YOUR_ALERT_ACTION_EVENTS_TABLE = 'ASK_YOUR_ALERT_ACTION_EVENTS_TABLE',
  ASK_YOUR_ALERT_ENTITIES_TABLE = 'ASK_YOUR_ALERT_ENTITIES_TABLE',
  ASK_YOUR_ALERT_INSTRUMENTS_TABLE = 'ASK_YOUR_ALERT_INSTRUMENTS_TABLE',
  RULE_ADMIN_SCENARIO_CONFIG_TABLE = 'RULE_ADMIN_SCENARIO_CONFIG_TABLE',
  RULE_ADMIN_CONTENT_TABLE = 'RULE_ADMIN_CONTENT_TABLE',
  RULE_ADMIN_QUERY_TABLE = 'RULE_ADMIN_QUERY_TABLE',
  RULE_ADMIN_EXECUTION_TABLE = 'RULE_ADMIN_EXECUTION_TABLE',
  RULE_ADMIN_VALIDATION_TABLE = 'RULE_ADMIN_VALIDATION_TABLE',
  RULE_ADMIN_SCHEDULE_TABLE = 'RULE_ADMIN_SCHEDULE_TABLE',
  RULE_ADMIN_RISK_MODEL_EXECUTION_TABLE = 'RULE_ADMIN_RISK_MODEL_EXECUTION_TABLE',
  RULE_ADMIN_RISK_MODEL_TABLE = 'RULE_ADMIN_RISK_MODEL_TABLE',
  RULE_ADMIN_RISK_MODEL_CONFIG_TABLE = 'RULE_ADMIN_RISK_MODEL_CONFIG_TABLE',
  RULE_ADMIN_ALERT_CONTENT_TABLE = 'RULE_ADMIN_ALERT_CONTENT_TABLE',
  RULE_ADMIN_ALERT_HIT_TABLE = 'RULE_ADMIN_ALERT_HIT_TABLE',
  DATA_SETTINGS_TABLE = 'DATA_SETTINGS_TABLE',
  AI_ADMIN_TRACKING_TABLE = 'AI_ADMIN_TRACKING_TABLE',
}

export interface ColumnMetadata {
  key: string;
  label: string;
  description?: string;
}

export interface LocalColumnConfig extends ColumnMetadata {
  hidden: boolean;
}

export type LocalTableConfigState = Partial<
  Record<LocalTableConfigType, LocalColumnConfig[]>
>;

export interface LocalTableConfigActionPayload {
  coordinates: { x: number; y: number };
  tableConfigType: LocalTableConfigType;
}
